import React from 'react';
import { ReactChat } from '@shared/components/proctoring/ReactChat';
import useAppStore from '../../stores/app';
import config from '../../config';
import { View } from '@smarterservices/smarter-ui';

/**
 * Chat Popup Window Component
 * 
 * Standalone popup window for the ReactChat component.
 * Provides a chat interface for the proctor room using the LiveKit room connection.
 * Opens in a separate browser window when triggered from the VTC interface.
 */
export const ChatPopup = () => {
    const roomSid = useAppStore((state) => state.roomSid);
    const user = useAppStore((state) => state.user);
    const mediaClient = useAppStore((state) => state.mediaClient);

    document.title = 'Chat - Virtual Test Center';

    // Don't render if we don't have the required data
    if (!roomSid || !user || !mediaClient) {
        return (
            <View padding="medium" textAlign="center">
                <p>Loading chat...</p>
            </View>
        );
    }

    return (
        <View height="100vh" width="100vw" display="block">
            <ReactChat
                roomId={roomSid}
                identity={user.sid}
                token={user.token}
                referenceId={roomSid}
                apiUrl={config.proctoring?.api?.baseUrl}
                websocketUrl={config.media?.livekit?.websocketUrl}
                displayName={`${user.firstName} ${user.lastName}`}
                allowNewMessage={true}
            />
        </View>
    );
};

export default ChatPopup;
